export default "__VITE_ASSET__C7W$ktEj__"